import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "background-modal"
}
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-form" }
const _hoisted_4 = { class: "contact-wp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"wrapper-contact-info\" data-v-65103bf1><p class=\"title\" data-v-65103bf1>Contáctanos</p><p class=\"subtitle\" data-v-65103bf1>¡Transformemos tu contenido en ventas!</p><div class=\"wrapper-info\" data-v-65103bf1><div class=\"info\" data-v-65103bf1><img class=\"icon\" src=\"assets/icons/Phone.svg\" alt=\"Teléfono\" data-v-65103bf1><p class=\"text-contact\" data-v-65103bf1>3105456982 - 3155764999 - 3502149948</p></div><div class=\"info\" data-v-65103bf1><img class=\"icon\" src=\"assets/icons/Email.svg\" alt=\"Correo\" data-v-65103bf1><p class=\"text-contact\" data-v-65103bf1>creandoideas@artisticvisionstudio.com.co</p></div><div class=\"info\" data-v-65103bf1><img class=\"icon\" src=\"assets/icons/Location.svg\" alt=\"Ubicación\" data-v-65103bf1><p class=\"text-contact\" data-v-65103bf1>Bogotá, Cundinamarca</p></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: "assets/icons/CloseBlack.svg",
              alt: "Cerrar",
              class: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }),
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-principal" }, "Escríbenos por WhatsApp", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-secondary" }, "Asesoría rápida y directa", -1)),
              _createElementVNode("img", {
                src: "assets/icons/WhatsappContact.svg",
                alt: "whatsapp",
                class: "icon-wp",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openWhatsApp && _ctx.openWhatsApp(...args)))
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}